import { request } from '../request';

export async function assignShift(id: string, staffId: string): Promise<void> {
  await request.post(`/v2/shifts/assign/${id}`, {
    staffId,
  });
}

export async function assignShifts(shiftIds: string[], staffId: string): Promise<void> {
  await request.post(`/v2/shifts/assign/bulk`, {
    staffId,
    shiftIds,
  });
}

export async function unassignShift(id: string, reason: string): Promise<void> {
  await request.post(`/v2/shifts/unassign/${id}`, {
    unassignReason: reason,
  });
}

export async function assignShiftRequestApprove(id: string): Promise<void> {
  await request.post(`/v2/shifts/${id}/external-assign-request/approve`, {});
}

export async function assignShiftRequestDecline(id: string, reason: string): Promise<void> {
  await request.post(`/v2/shifts/${id}/external-assign-request/decline`, {
    reason,
  });
}

export async function assignRequestsConflictCount(): Promise<number> {
  const response = await request.get<{ count: number }>(`/v2/shifts/assign-request-conflict-count`);
  return Number(response.data.count);
}
